import type { ServerPaginationConfig } from '@shared/types/module-config';

export const WALLET_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const WALLETS_ROUTE_PATHS = {
  wallets: '/movements/wallets',
};

export const WALLETS_API_PATHS = {
  movements: '/v1/api/platform/wallets/movements',
  movementDetail: '/v1/api/platform/wallets/movements',
  movementsOrigin: '/v1/api/platform/wallets/movements/origin',
  userSearch: '/v1/api/platform/users',
  refundPurchase: '/v1/api/platform/wallets/movements',
  transferDetail: '/v1/api/platform/transfers/transfers-detail',
  withdrawalDetail: '/v1/api/platform/withdrawals',

};
